module.exports = __webpack_public_path__ + "static/media/smoking.3539e7d3.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/smoking.svg
// module id = 843
// module chunks = 0 1